import React from 'react';
import { WarningFilled } from '@ant-design/icons';
import { BaseAlertBanner } from '@components';
import { AbsoluteWrapper as Wrapper } from '@components/alert-banner/styled.tsx';
import { Trans } from '@lingui/react/macro';

interface Props {
    recordsUploaded: number;
    recordsRejected: number;
    filename: string;
}

export const CSVImportWithErrorsBanner: React.FC<Props> = ({ recordsUploaded, recordsRejected, filename }) => (
    <Wrapper $width={'35%'}>
        <BaseAlertBanner
            closable
            type="warning"
            title={filename}
            description={
                <Trans>
                    {recordsUploaded} records uploaded successfully, {recordsRejected} records with error(s) rejected
                </Trans>
            }
            icon={<WarningFilled />}
        />
    </Wrapper>
);
